<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .75s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>

<script>

    export default {
        data () {
            return {
                searchVisible: false
            }
        },
        mounted () {
        },
        props: [
        ],
        methods: {
            showSearch () {
                this.searchVisible = true
            },
            hideSearch () {
                this.searchVisible = false
            }
        }
    }
</script>